var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPessoas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21",
    "data-name": "Grupo 21",
    transform: "translate(-463 -837)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_3",
    "data-name": "Elipse 3",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(463 837)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5",
    "data-name": "Caminho 5",
    d: "M25.874,26.2a13.641,13.641,0,0,0,5.611-.718,4.5,4.5,0,0,0-7.023-4.08m1.41,4.8v.047a8.8,8.8,0,0,1-.056,1,18.024,18.024,0,0,1-17.889,0A9.093,9.093,0,0,1,7.874,26.2m18,0a8.956,8.956,0,0,0-1.412-4.8m0,0a9,9,0,0,0-15.175,0m0,0a4.5,4.5,0,0,0-7.021,4.08,13.479,13.479,0,0,0,5.61.715m1.41-4.8a8.956,8.956,0,0,0-1.41,4.8M21.374,8.25a4.5,4.5,0,1,1-4.5-4.5A4.5,4.5,0,0,1,21.374,8.25Zm9,4.5A3.375,3.375,0,1,1,27,9.375,3.375,3.375,0,0,1,30.374,12.75Zm-20.25,0A3.375,3.375,0,1,1,6.749,9.375,3.375,3.375,0,0,1,10.124,12.75Z",
    transform: "translate(464.249 838.75)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPessoas);
export default __webpack_public_path__ + "static/media/icon_pessoas.311471bd6d15d0cce4f82d8bec0ff6d8.svg";
export { ForwardRef as ReactComponent };